import { useEffect, useRef, useState } from "react";

/** Load once near the actual site scroll container; never unload on scrolling away. */
export function useNearViewport<T extends HTMLElement>(
  rootMargin = "400px 0px"
) {
  const ref = useRef<T | null>(null);
  const [nearby, setNearby] = useState(
    () => typeof IntersectionObserver === "undefined"
  );

  useEffect(() => {
    const element = ref.current;
    if (!element || nearby) return;
    let active = true;
    const observer = new IntersectionObserver(
      (entries) => {
        if (
          !active ||
          !entries.some(
            (entry) => entry.target === element && entry.isIntersecting
          )
        )
          return;
        setNearby(true);
        observer.disconnect();
      },
      { root: element.closest("[data-site-scroll]"), rootMargin }
    );
    observer.observe(element);
    return () => {
      active = false;
      observer.disconnect();
    };
  }, [nearby, rootMargin]);

  return [ref, nearby] as const;
}
